export const validateVideo = (content: string): boolean => content?.includes('</video>');
